<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="400"
      persistent
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          small
          outlined
          color="primary"
          v-bind="attrs"
          v-on="on"
          :disabled="loading"
        >
          <template v-if="loading">
            <v-icon class="mr-2 rotate" color="white">mdi-loading</v-icon>
            Processando...
          </template>
          <template v-else>
            {{ title }}
            <v-icon right>mdi-export</v-icon>
          </template>
        </v-btn>
      </template>

      <v-card class="pa-3">
        <p class="text-subtitle-1">Selecione o intervalo a ser exportado</p>
        <div class="d-flex justify-around">
          <v-col
            cols="12"
            sm="6"
          >
            <v-menu
              ref="startMenu"
              v-model="startMenu"
              :close-on-content-click="false"
              :return-value.sync="interval.start"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="computedStartDate"
                  label="Data inicial"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="interval.start"
                no-title
                scrollable
                :max="new Date().toISOString()"
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="startMenu = false"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.startMenu.save(interval.start)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col
            cols="12"
            sm="6"
          >
            <v-menu
              ref="endMenu"
              v-model="endMenu"
              :close-on-content-click="false"
              :return-value.sync="interval.end"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="computedEndDate"
                  label="Data final"
                  prepend-icon="mdi-calendar"
                  readonly
                  :disabled="!interval.start"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="interval.end"
                no-title
                scrollable
                :max="new Date().toISOString()"
                :min="new Date(interval.start).toISOString()"
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="endMenu = false"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.endMenu.save(interval.end)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
        </div>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            variant="plain"
            @click="close"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="primary"
            variant="tonal"
            :disabled="loading"
            @click="exportData"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: 'ExportPlaceData',
  props: {
    onClick: {
      type: Function,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  data: () => ({
    dialog: false,
    startMenu: false,
    endMenu: false,
    loading: false,
    interval: { start: null, end: null }
  }),
  methods: {
    async exportData() {
      const now = dayjs(new Date().toISOString()).format("YYYY-MM-DD")

      const _interval = {
        start: this.interval.start,
        end: this.interval.end ? this.interval.end : now
      }

      this.loading = true
      this.close()

      await this.onClick(_interval)

      this.loading = false
    },
    close() {
      this.dialog = false
      this.interval = { start: null, end: null }
    }
  },
  computed: {
    computedStartDate() {
      if (!this.interval.start) return "-"

      return dayjs(this.interval.start).format("DD/MM/YYYY")
    },
    computedEndDate() {
      if (!this.interval.end) return "-"

      return dayjs(this.interval.end).format("DD/MM/YYYY")
    },
  }
}
</script>
